import { useCallback } from "react";
import i18n from "i18n/i18next";
export const useFormatTranslation = () => {
  const formatTranslation = useCallback(
    (
      text: string,
      options?: {
        transType?: string;
        transContext?: string;
        alternate?: string;
      },
    ) => {
      if (options?.transType) {
        switch (options?.transType) {
          case "labelWithDate":
            const values = text.split(" ");

            /// Fallback to reformat time as will be in wrong format
            try {
              const dateValues = values.slice(1);
              const timeFromString = dateValues.join(" ");

              return i18n.t("cards.label", {
                label: i18n.t(`cards.${values[0]!.replace(" ", "-").toLowerCase()}`, { context: options?.transContext }),
                time: timeFromString,
              });
            } catch {
              return i18n.t("cards.label", {
                label: i18n.t(`cards.${values[0]!.replace(" ", "-").toLowerCase()}`, { context: options?.transContext }),
                time: values[1],
              });
            }

          case "altOnly":
            if (options?.alternate && text === options?.alternate.slice(5)) {
              return i18n.t(`cards.${text.replace(/ & /g, "-&-").replace(" ", "-").toLowerCase()}`, {
                context: options?.transContext,
              });
            } else {
              return text;
            }
        }
      }
      return i18n.t(`cards.${text.replace(/ & /g, "-&-").replace(" ", "-").toLowerCase()}`, {
        context: options?.transContext,
      });
    },
    [],
  );
  return { formatTranslation };
};
